import { Injectable, ViewChildren, QueryList } from '@angular/core';
import {
  CdkDragDrop,
  moveItemInArray,
  CdkDropList,
  CdkDragEnter,
  CdkDragStart,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { v4 as uuidv4 } from 'uuid';
import { DgDialogService } from 'src/app/digigov/dg_components/dg-dialog/dg-dialog.service';
import {
  comboMap,
  columnConfigJ,
  MatTableColumnConfig,
  gridConfigJ,
  treeDataApiUrlSt,
} from './appgen-default-fields';
import { HttpClient } from '@angular/common/http';
import { Observable, asapScheduler, Subject, throwError } from 'rxjs';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AttributeDialogComponent } from '../attribute-dialog/attribute-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SampleDialogComponent } from 'src/app/digigov/dg_components_test/dg-dynamic-grid-test/dg-dynamic-grid-test.component';
import { Router } from '@angular/router';
import { TableConfigDialogComponent } from '../table-config-dialog/table-config-dialog.component';
import { catchError, map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { MessageDisplayService } from 'src/app/digigov/services/message-display/message-display.service';
import { AdvancedRuleScreenComponent } from '../advanced-rule-screen/advanced-rule-screen.component';
import { ConfigurationAuditComponent } from '../configuration-audit/configuration-audit.component';
import { AppgenAuditService } from './app-gen-audit.service';

@Injectable({
  providedIn: 'root',
})
export class AppGenFormbuilderService {
  layoutValue: number;
  jsonComboMap: any = {};
  formId: any;
  formLayout: any;
  comboMapObj: any = {};
  formUIList: any = [];
  foundationUIList: any = [];
  layoutUIList: any = [];
  jsonData: any = {
    form_status: Boolean,

    componetDetails: [],
  };
  componentList = [];
  formDesignerComponents: any = [];
  formVersionId: any;
  count: any = this.jsonData.componetDetails.length;
  attributeJson: any = [];

  attributeList: any;
  componentsData: any;
  jsonField: any = [];
  expForm: any;
  idMap = {};
  myMethod$: Observable<any>;
  formStatus: boolean;
  comboIdData: any;
  formName: any;
  event: any;
  selectedParentComboValue: any;
  developerFormData;
  appName: any;
  appId: any;

  // AUDITDATA SETS THROUGH API
  auditData: any = [];
  jsonDataRaw: any;
  isDraggedFromPalette: boolean = false;

  private myMethodSubject = new Subject<any>();

  parentDtlsBefore = null;
  parentDtls = null;

  urlMethod(data) {
    this.myMethodSubject.next(data);

    this.jsonData.formId = data.formId;
    this.jsonData.formName = data.formName;

    this.jsonData.formVersionMpgId = data.formVersionId;
    this.jsonData.form_status = data.formStatus;
    this.formStatus = data.formStatus;
    this.appId = data.appId;
    this.formId = data.formId;
    this.formName = data.formName;
    this.appName = data.appName;
  }
  constructor(
    private httpClient: HttpClient,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private msgDsplyService: MessageDisplayService,
    private dialogService: DgDialogService,
    private auditService: AppgenAuditService
  ) {
    this.myMethod$ = this.myMethodSubject.asObservable();
  }
  @ViewChildren(CdkDropList)
  private dlq: QueryList<CdkDropList>;
  uiTech: any = 'angular';
  setExpForm(expForm: any) {
    this.expForm = expForm;
  }
  loadComponents() {
    this.getAttributeJson();
    this.getComboIds('533112');
    this.getComponentsData(this.uiTech).subscribe((res: any) => {
      let resData: any = res.data;
      // resData.push({
      //   activeFlag: 0,
      //   cmpntCategory: "B",
      //   cmpntDesc: "Icon Button",
      //   cmpntId: 410,
      //   cmpntName: "IconButton",
      //   cmpntType: 5332000,
      //   crtDt: null,
      //   crtPost: null,
      //   lstUpdtDt: null,
      //   lstUpdtPost: null,
      //   uiTech: 0
      // })

      //this.getcomboId();
      this.componentsData = resData;
      this.getKeys(this.componentsData).forEach((components) => {
        var componentName = {
          type: this.componentsData[components].cmpntName,
          category: this.componentsData[components].cmpntCategory,
          id: this.componentsData[components].cmpntId,
          name: '',
          displayName: this.componentsData[components].cmpntDesc,
        };

        if (this.componentsData[components].cmpntCategory == 'B') {
          // this.formUIList.push(this.componentsData[components].cmpntName);
          this.formUIList.push(componentName);
        }
        if (this.componentsData[components].cmpntCategory == 'D') {
          // this.foundationUIList.push(
          //   this.componentsData[components].cmpntName
          // );
          this.foundationUIList.push(componentName);
        }
        if (
          this.componentsData[components].cmpntCategory == 'L' &&
          (this.componentsData[components].cmpntName == 'Card' ||
            this.componentsData[components].cmpntName == 'AppGenCheckList' ||
            this.componentsData[components].cmpntName == 'Stepper' ||
            this.componentsData[components].cmpntName == 'ExpansionPanel' ||
            this.componentsData[components].cmpntName == 'Tab' ||
            this.componentsData[components].cmpntName == 'DataTable' ||
            this.componentsData[components].cmpntName == 'Column' ||
            this.componentsData[components].cmpntName == 'MatTable')
        ) {
          // this.layoutUIList.push(this.componentsData[components].cmpntName);

          this.layoutUIList.push(
            this.makeLayoutComponent(
              this.componentsData[components].cmpntName,
              this.componentsData[components].cmpntId
            )
          );
        }
      });
    });
  }
  makeLayoutComponent(cmpType: any, cmpId: any) {
    switch (cmpType) {
      case 'Stepper':
        var stepper = [
          {
            type: 'Stepper',
            label: 'Steper',
            componentId: 52,
            isAddUpdate: 'update',
            iconName: 'read_more',
            entityAttriMpgId: null,
            pkAttrDtlId: null,

            hideShow: { optionValue: 'false', optionText: 'false' },
            components: [
              {
                label: 'step 1',
                name: 'step1',
                entityAttriMpgId: null,
                pkAttrDtlId: null,
                isAddUpdate: 'update',
                componentId: 56,
                id: null,
                isEntity: { optionValue: 'false', optionText: 'false' },

                hideShow: { optionValue: 'false', optionText: 'false' },
                components: [],
              },
              {
                label: 'step 2',
                name: 'step2',
                id: null,
                entityAttriMpgId: null,
                pkAttrDtlId: null,
                isAddUpdate: 'update',
                componentId: 56,
                isEntity: { optionValue: 'false', optionText: 'false' },

                hideShow: { optionValue: 'false', optionText: 'false' },
                components: [],
              },
              {
                label: 'step 3',
                name: 'step3',
                entityAttriMpgId: null,
                pkAttrDtlId: null,
                isAddUpdate: 'update',
                id: null,
                componentId: 56,
                isEntity: { optionValue: 'false', optionText: 'false' },

                hideShow: { optionValue: 'false', optionText: 'false' },
                components: [],
              },
            ],
          },
        ];
        return stepper;
        break;
      case 'Tab':
        var tabJson = [
          {
            type: 'Tab',
            label: 'Tab',
            componentId: 57,
            entityAttriMpgId: null,
            pkAttrDtlId: null,
            isAddUpdate: 'update',
            iconName: 'view_list',
            id: null,
            components: [
              {
                label: 'Tab 1',
                name: 'tab1',
                componentId: 48,
                entityAttriMpgId: null,
                pkAttrDtlId: null,
                isAddUpdate: 'update',
                id: null,
                isEntity: { optionValue: 'false', optionText: 'false' },
                enableDisable: { optionValue: 'false', optionText: 'false' },
                hideShow: { optionValue: 'false', optionText: 'false' },
                components: [],
              },
              {
                label: 'Tab 2',
                name: 'tab2',
                componentId: 48,
                entityAttriMpgId: null,
                pkAttrDtlId: null,
                isAddUpdate: 'update',
                id: null,
                isEntity: { optionValue: 'false', optionText: 'false' },
                enableDisable: { optionValue: 'false', optionText: 'false' },
                hideShow: { optionValue: 'false', optionText: 'false' },
                components: [],
              },
            ],
          },
        ];
        return tabJson;
        break;
      case 'Step':
        var step1 = {
          type: cmpType,
          label: 'step 1',
          name: 'step1',
          components: [],
        };
        return step1;
        break;
      case 'ExpansionPanel':
        var expansionPanel = [
          {
            type: 'ExpansionPanel',
            label: 'ExpansionPanel',
            iconName: 'view_list',
            componentId: 37,
            id: 1,
            components: [
              {
                label: 'Title 1',
                summary: 'Summary content 1',
                name: 'panel1',
                entityAttriMpgId: null,
                pkAttrDtlId: null,
                isAddUpdate: 'update',
                componentId: 37,

                hideShow: { optionValue: 'false', optionText: 'false' },
                components: [],
              },
              {
                label: 'Title 2',
                summary: 'Summary content 2',
                name: 'panel2',
                entityAttriMpgId: null,
                pkAttrDtlId: null,
                isAddUpdate: 'update',
                componentId: 37,

                hideShow: { optionValue: 'false', optionText: 'false' },
                components: [],
              },
            ],
          },
        ];
        return expansionPanel;
        break;
      case 'Card':
        var card = [
          {
            type: 'Card',
            label: 'Card',
            entityAttriMpgId: null,
            pkAttrDtlId: null,
            componentId: 36,
            iconName: 'inventory_2',
            components: [],
          },
        ];
        return card;
        break;
      case 'AppGenCheckList':
        var checklist = [
          {
            type: 'AppGenCheckList',
            label: 'AppgenCheckList',
            entityAttriMpgId: null,
            pkAttrDtlId: null,
            componentId: 65,
            iconName: 'inventory_2',
            components: [],
          },
        ];
        return checklist;
        break;
      case 'DataTable':
        var dataGrid = [
          {
            type: 'DataTable',
            label: 'DataTable',
            componentId: 35,
            entityAttriMpgId: null,
            pkAttrDtlId: null,
            isAddUpdate: 'update',
            colconfig: '',
            name: 'DataTable',
            iconName: 'grid_on',
            id: null,
            components: [
              {
                label: 'Col 1',
                name: 'col1',
                componentId: 35,
                entityAttriMpgId: null,
                pkAttrDtlId: null,
                isAddUpdate: 'update',
                id: null,
                components: [],
                hideShow: { optionValue: 'false', optionText: 'false' },
                checkDuplicate: { optionValue: 'false', optionText: 'false' },
              },
              {
                label: 'Col 2',
                name: 'col2',
                componentId: 35,
                entityAttriMpgId: null,
                pkAttrDtlId: null,
                isAddUpdate: 'update',
                id: null,
                components: [],
                hideShow: { optionValue: 'false', optionText: 'false' },
                checkDuplicate: { optionValue: 'false', optionText: 'false' },
              },
              {
                label: 'Col 3',
                name: 'col3',
                componentId: 35,
                entityAttriMpgId: null,
                pkAttrDtlId: null,
                isAddUpdate: 'update',
                id: null,
                components: [],
                hideShow: { optionValue: 'false', optionText: 'false' },
                checkDuplicate: { optionValue: 'false', optionText: 'false' },
              },
            ],
          },
        ];
        return dataGrid;
        break;
      case 'Column':
        var Column = [
          {
            type: 'Column',
            label: 'Column',
            componentId: 64,
            entityAttriMpgId: null,
            pkAttrDtlId: null,
            isAddUpdate: 'update',
            colconfig: '',
            name: 'Column',
            iconName: 'grid_on',
            id: null,
            components: [
              {
                label: 'Col 1',
                name: 'col1',
                columnClass: 'col',
                componentId: 64,
                isAddUpdate: 'update',
                id: null,
                components: [],
                hideShow: { optionValue: 'false', optionText: 'false' },
              },
              {
                label: 'Col 2',
                name: 'col2',
                columnClass: 'col',
                componentId: 64,
                isAddUpdate: 'update',
                id: null,
                components: [],
                hideShow: { optionValue: 'false', optionText: 'false' },
              },
              {
                label: 'Col 3',
                name: 'col3',
                columnClass: 'col',
                componentId: 64,
                isAddUpdate: 'update',
                id: null,
                components: [],
                hideShow: { optionValue: 'false', optionText: 'false' },
              },
            ],
          },
        ];
        return Column;
        break;
      case 'MatTable':
        var tableJson = [
          {
            type: 'MatTable',
            label: 'MatTable',
            iconName: 'grid_on',
            id: 1,
            row: [
              [
                {
                  label: 'col 1',
                  isAddUpdate: 'update',
                  name: 'col1',
                  id: null,
                  components: [],
                },
                {
                  label: 'col 2',
                  name: 'col2',
                  id: null,
                  components: [],
                },
                {
                  label: 'col 3',
                  name: 'col3',
                  id: null,
                  components: [],
                },
                {
                  label: 'col 4',
                  name: 'col4',
                  id: null,
                  components: [],
                },
              ],
              [
                {
                  label: 'col 5',
                  name: 'col5',
                  id: null,
                  components: [],
                },
                {
                  label: 'col 6',
                  name: 'col6',
                  id: null,
                  components: [],
                },
                {
                  label: 'col 7',
                  name: 'col7',
                  id: null,
                  components: [],
                },
                {
                  label: 'col 8',
                  name: 'col8',
                  id: null,
                  components: [],
                },
              ],
              [
                {
                  label: 'col 5',
                  name: 'col5',
                  id: null,
                  components: [],
                },
                {
                  label: 'col 6',
                  name: 'col6',
                  id: null,
                  components: [],
                },
                {
                  label: 'col 7',
                  name: 'col7',
                  id: null,
                  components: [],
                },
                {
                  label: 'col 8',
                  name: 'col8',
                  id: null,
                  components: [],
                },
              ],
            ],
          },
        ];
        return tableJson;
        break;
      default:
        var other = [
          {
            type: cmpType,
            label: cmpType,
            id: cmpId,
            iconName: 'inventory_2',

            components: [],
          },
        ];
        return other;
        break;
    }
  }
  getAttributeJson(): void {
    this.getComponentsAttributeData(this.uiTech).subscribe((res: any) => {
      let resData: any = res?.data;
      this.attributeList = resData;
      console.log('atttrrrr list', this.attributeList);
      this.getKeys(this.attributeList).forEach((attributes, index) => {
        let jsonAttr = {
          type: attributes,
          attribute: [],
          componentId: '',
        };
        let jsonArrayObj: any = this.attributeList[attributes];
        this.getKeys(jsonArrayObj).forEach((attributes, index) => {
          let validationJ = jsonArrayObj[attributes].validation;
          let defalutVal = jsonArrayObj[attributes].defaultVal;

          if (defalutVal != null) {
            if (typeof defalutVal === 'string' && this.isJson(defalutVal)) {
              defalutVal = defalutVal.replace(/\\/g, '');
              try {
                defalutVal = JSON.parse(defalutVal);
              } catch (e) {
                defalutVal = jsonArrayObj[attributes].defaultVal;
              }
            } else if (typeof defalutVal === 'number') {
              defalutVal = Number(defalutVal);
            } else if (typeof defalutVal === 'boolean') {
              defalutVal = Boolean(defalutVal);
            } else if (
              typeof defalutVal == 'object' &&
              this.isJson(defalutVal)
            ) {
              defalutVal = defalutVal.replace(/\\/g, '');
              defalutVal = JSON.parse(defalutVal);
            }
          }

          if (validationJ != null) {
            if (typeof validationJ === 'string' && this.isJson(validationJ)) {
              validationJ = validationJ.replace(/\\/g, '');
              validationJ = JSON.parse(validationJ);
            } else if (typeof validationJ === 'number') {
              validationJ = Number(validationJ);
            } else if (typeof validationJ === 'boolean') {
              validationJ = Boolean(validationJ);
            } else if (typeof validationJ == 'object') {
              validationJ = validationJ.replace(/\\/g, '');
              validationJ = JSON.parse(validationJ);
            }
          }

          let validationsArray = [];

          if (validationJ != null) {
            if (validationJ.rules.required) {
              validationsArray.push(Validators.required);
            }
            if (validationJ.rules.maxLength) {
              validationsArray.push(
                Validators.maxLength(validationJ.rules.maxLength)
              );
            }
            if (validationJ.rules.format) {
              validationsArray.push(
                Validators.pattern(validationJ.rules.format)
              );
            }
          }

          // if (jsonArrayObj[attributes].isMandatory === 1) {
          //   this.expForm.addControl(
          //     jsonArrayObj[attributes].prpName,
          //     this.fb.control('', [Validators.required])
          //   );
          // } else if (jsonArrayObj[attributes] != null) {
          //   this.expForm.addControl(
          //     jsonArrayObj[attributes].prpName,
          //     this.fb.control('')
          //   );
          // }
          if (jsonArrayObj[attributes] != null) {
            this.expForm.addControl(
              jsonArrayObj[attributes].prpName,
              this.fb.control('', validationsArray)
            );
          }
          // let otherValidators = this.expForm.controls[jsonArrayObj[attributes].prpName].validator('');

          this.jsonField = {
            name: jsonArrayObj[attributes].prpName,
            label: jsonArrayObj[attributes].prpDesc,
            placeholder: jsonArrayObj[attributes].prpDesc,
            defaultValue: defalutVal,
            defaultValue1: null,
            type: jsonArrayObj[attributes].prpValueType,
            validation: validationJ,
          };
          jsonAttr.attribute.push(this.jsonField);
          jsonAttr.componentId = jsonArrayObj[0].cmpntId;
        });
        this.attributeJson.push(jsonAttr);
      });
    });
  }
  getKeys(map: any) {
    if (map) return Object.keys(map);
  }
  isJson(str: any) {
    try {
      if (str.match(/\\$/)) {
        if (typeof str == 'string') {
          str.replace(/\\/g, '');

          JSON.parse(str);
        } else if (typeof str == 'object') {
          str.replace(/\\/g, '');
          JSON.parse(str);
        }
      }
    } catch (e) {
      return false;
    }
    return true;
  }
  setQueryList(dlq: QueryList<CdkDropList>) {
    this.dlq = dlq;
  }
  changeObjectState(idMap: any, tempMap: any) {
    const tempFormUIList = JSON.parse(JSON.stringify(this.formUIList));
    tempFormUIList.forEach((c) => {
      c.id = tempMap[c.type] ? tempMap[c.type] + 1 : 1;
      c.name = tempMap[c.type] ? c.type + c.id : c.type + c.id;
    });
    this.formUIList = tempFormUIList;
    this.formUIList = [...this.formUIList];

    const tempFoundationUIList = JSON.parse(
      JSON.stringify(this.foundationUIList)
    );
    tempFoundationUIList.forEach((c) => {
      c.id = tempMap[c.type] ? tempMap[c.type] + 1 : 1;
      c.name = tempMap[c.type] ? c.type + c.id : c.type + c.id;
    });
    this.foundationUIList = tempFoundationUIList;
    this.foundationUIList = [...this.foundationUIList];

    const tempLayoutUIList = JSON.parse(JSON.stringify(this.layoutUIList));
    tempLayoutUIList.forEach((c) => {
      c.id = tempMap[c.type] ? tempMap[c.type] + 1 : 1;
      c.name = tempMap[c.type] ? c.type + c.id : c.type + c.id;
    });
    this.layoutUIList = tempLayoutUIList;
    this.layoutUIList = [...this.layoutUIList];
  }

  public dls: CdkDropList[] = [];

  public drop(event: CdkDragDrop<any>) {
    let eventCopy = Object.assign({
      container: event.container.data,
      currentIndex: event.currentIndex,
      previousIndex: event.previousIndex,
      previousContainer: event.previousContainer.data,
    });
    let eventDeepCopy = JSON.stringify(eventCopy);
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      // AUDIT WITHIN SAME PARENT COMPONENT
      this.auditService.auditV2.dragDetails.previousIndex = JSON.parse(
        eventDeepCopy
      ).previousIndex;
      this.auditService.auditV2.dragDetails.currentIndex = JSON.parse(
        eventDeepCopy
      ).currentIndex;
      this.auditService.auditV2.dragDetails.status = true;
      let ele = JSON.parse(eventDeepCopy).container[eventCopy.currentIndex];

      let parentDtls = this.getParentCompDtls(
        this.jsonData.componetDetails,
        ele.id
      );
      if (!parentDtls) {
        console.log('inside');
        parentDtls = Object.assign({ label: this.formName });
      }
      console.log('dtls', parentDtls);
      this.auditService.auditV2.dragDetails.prevParentComp = parentDtls;
      this.auditService.auditV2.dragDetails.currParentComp = parentDtls;

      this.auditService.auditV2.fieldName = ele['label'];
      this.auditService.auditV2.fieldId = ele['id'];
      this.auditService.auditV2.fieldType = ele['componentType'];
      // this.auditService.auditV2.status = JSON.stringify(this.auditV2.dragDetails)
      this.auditService.auditDragList.splice(0, 0, this.auditService.auditV2);
    } else {
      if ('formComponents' == event.previousContainer.id) {
        this.isDraggedFromPalette = true;
        this.ondrop(event);
      } else {
        // AUDIT WITHIN DIFFERENT PARENT COMPONENT
        this.onChangeDropObject(event);
      }
    }
  }
  getParentCompDtls(formDetails, fieldId, storeParent?) {
    formDetails.forEach((component) => {
      if (!Array.isArray(component)) {
        if (component?.id == fieldId) {
          this.parentDtls = storeParent;
        }
      }

      if (Array.isArray(component)) {
        this.getParentCompDtls(component, fieldId);
      }
      if (
        Array.isArray(component?.components) &&
        component?.components.length > 0
      ) {
        let storeParent;
        if (
          component?.componentId == 48 ||
          component?.componentId == 57 ||
          component?.componentId == 65
        ) {
          storeParent = component;
        }
        this.getParentCompDtls(component?.components, fieldId, storeParent);
      }
    });
    return this.parentDtls;
  }
  onChangeDropObject(event) {
    let jsonItem = event.previousContainer.data[event.previousIndex];
    // AUDIT STARTS
    this.parentDtlsBefore = this.getParentCompDtls(
      this.jsonData.componetDetails,
      jsonItem.id
    );
    if (!this.parentDtlsBefore) {
      this.parentDtlsBefore = Object.assign({ label: this.formName });
    }
    let typeOfComponent =
      event.previousContainer.data[event.previousIndex].type != undefined
        ? event.previousContainer.data[event.previousIndex]
        : event.previousContainer.data[event.previousIndex][0];
    typeOfComponent.deleteComponent = 'delete';
    typeOfComponent.isAddUpdate = 'update';
    this.jsonData.componetDetails = this.formDesignerTocomponent(
      this.formDesignerComponents
    );
    this.jsonData.form_status = this.formStatus;
    this.jsonData.formName = this.formName;

    this.saveFormData(this.jsonData).subscribe((res: any) => {
      if (res.data.status) {
        this.msgDsplyService.errorToast({
          errors: [
            {
              message: res.messages?.[0],
            },
          ],
        });
        this.router.navigate(['main/appgen-form-version'], {
          queryParams: {
            formIdToSend: this.formId,
            appId: this.appId,
            appName: this.appName,
          },
        });
      } else {
        event.previousContainer.data.splice(event.previousIndex, 1);
        this.jsonData = res.data.resultValue;
        let jsonItem1 = { ...jsonItem };
        if (jsonItem1[0]) {
          let jsonItem2 = jsonItem1[0];
          delete jsonItem2.deleteComponent;
          jsonItem2.isAddUpdate = 'update';
          // jsonItem1.id = null;
          jsonItem2.uuid = uuidv4();
          event.container.data.splice(event.currentIndex, 0, jsonItem2);
        } else {
          delete jsonItem1.deleteComponent;
          jsonItem1.isAddUpdate = 'update';
          // jsonItem1.id = null;
          jsonItem1.uuid = uuidv4();
          event.container.data.splice(event.currentIndex, 0, jsonItem1);
        }
        this.jsonData.componetDetails = this.formDesignerComponents;
        // AUDIT STARTS
        let parentDtlsAfter = this.getParentCompDtls(
          this.jsonData.componetDetails,
          jsonItem.id
        );
        if (!parentDtlsAfter) {
          console.log('inside');
          parentDtlsAfter = Object.assign({ label: this.formName });
        }
        console.log('dtls', parentDtlsAfter);
        // AUDIT WITH DIFFERENT PARENT COMPONENT
        this.auditService.auditV2.dragDetails.previousIndex =
          event.previousIndex;
        this.auditService.auditV2.dragDetails.currentIndex = event.currentIndex;
        this.auditService.auditV2.dragDetails.currParentComp = parentDtlsAfter;
        this.auditService.auditV2.dragDetails.prevParentComp = this.parentDtlsBefore;
        this.auditService.auditV2.dragDetails.status = true;
        // let ele = event.previousContainer.data[event.previousIndex];

        this.auditService.auditV2.fieldName = jsonItem['label'];
        this.auditService.auditV2.fieldId = jsonItem['id'];
        this.auditService.auditV2.fieldType = jsonItem['componentType'];
        this.auditService.auditDragList.splice(0, 0, this.auditService.auditV2);

        if (res.data.resultValue.componetDetails.length != 0) {
          this.uuIdContainer = [];
          this.formDesignerComponents = this.componentToFormDesigner(
            this.jsonData.componetDetails
          );
        } else {
          this.formDesignerComponents = [];
        }
        this.saveFormObj();
        this.parentDtlsBefore = null;
      }
    });
  }
  ondrop(event) {
    let jsonItem = event.previousContainer.data[event.previousIndex];
    let typeOfComponent =
      event.previousContainer.data[event.previousIndex].type != undefined
        ? event.previousContainer.data[event.previousIndex]
        : event.previousContainer.data[event.previousIndex][0];
    event.container.data.splice(event.currentIndex, 0, jsonItem);
    this.checkDataTable = false;
    this.checkDataTable = this.checkDataTableObj(
      this.formDesignerComponents,
      event
    );
    if (!this.checkDataTable) {
      event.container.data.splice(event.currentIndex, 1);
      this.generateComponent(
        event.previousIndex,
        event.currentIndex,
        event,
        typeOfComponent
      );
      this.idMap = {};
      const tempMap = this.getIds(this.formDesignerComponents);
      this.changeObjectState(this.idMap, tempMap);
      event.container.data.splice(event.currentIndex, 0, jsonItem);
      this.jsonData.componetDetails = event.container.data;
    }
  }
  getConnectedList(): void {
    let ldls: CdkDropList[] = [];

    this.dlq.forEach((dl) => {
      ldls.push(dl);
    });

    ldls = ldls.reverse();

    asapScheduler.schedule(() => {
      this.dls = ldls;
    });
  }

  isArray(item: any): boolean {
    return Array.isArray(item);
  }

  getComponentsData(uiTech: any): Observable<any> {
    return this.httpClient.get('/appgen/components?uiTech=' + uiTech);
  }
  getComponentsAttributeData(uiTech: any): Observable<any> {
    return this.httpClient.get(
      '/appgen/allcomponentProperties?uiTech=' + uiTech
    );
  }

  saveFormData(data: any) {
    return this.httpClient.post('/appgen/saveFormField', data);
  }
  saveForm(data: any) {
    return this.httpClient.post('/appgen/saveForm', data);
  }

  loadFormData(data: any) {
    return this.httpClient.post('/appgen/renderingAdminScreen', data);
  }
  unlockForm(data: any) {
    return this.httpClient.post('/appgen/unlock-form', data);
  }
  public onDragEntered(event: CdkDragEnter) {
    this.enforceDragToSelf(event.container);
  }

  public onDragStarted(event: CdkDragStart) {
    this.enforceDragToSelf(event.source.dropContainer);
  }

  private enforceDragToSelf(dl: CdkDropList) {
    const siblings = dl.connectedTo as CdkDropList<any>[];

    const ref = dl._dropListRef;
    asapScheduler.schedule(() => {
      ref.connectedTo(siblings.map((list) => list._dropListRef));
    });
  }
  getIds(dataList): Object {
    if (dataList != null && dataList != undefined) {
      dataList.forEach((c) => {
        if (Array.isArray(c)) {
          if (this.idMap[c[0].type]) {
            let id = Number(this.idMap[c[0].type]);
            id = id + 1;
            this.idMap[c[0].type] = id;
          } else {
            this.idMap[c[0].type] = 1;
          }
          if (c[0].components && c[0].components.length > 0) {
            this.getIds(c[0].components);
          }
        } else {
          if (this.idMap[c.type]) {
            let id = Number(this.idMap[c.type]);
            id = id + 1;
            this.idMap[c.type] = id;
          } else {
            this.idMap[c.type] = 1;
          }
        }
      });
    }
    return this.idMap;
  }
  generateComponent(
    elementIndex: number,
    previousAddedIndex: number,
    event: CdkDragDrop<any>,
    componentObj: any
  ) {
    var orderNumber: number = Number(previousAddedIndex) * 10;
    let typeOfComponent =
      event.previousContainer.data[elementIndex].type != undefined
        ? event.previousContainer.data[elementIndex].type
        : event.previousContainer.data[elementIndex][0].type;

    switch (typeOfComponent) {
      case 'TextInput':
        this.prepareJson(
          elementIndex,
          'textbox-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );

        break;
      case 'Chips':
        this.prepareJson(
          elementIndex,
          'chips-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );

        break;
      case 'Label':
        this.prepareJson(
          elementIndex,
          'label-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );

        break;
      case 'Divider':
        this.prepareJson(
          elementIndex,
          'divider-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );

        break;

      case 'Stepper':
        this.prepareJson(
          elementIndex,
          'stepper-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );

        break;
      case 'Tab':
        this.prepareJson(
          elementIndex,
          'tab-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );

        break;
      case 'ExpansionPanel':
        this.prepareJson(
          elementIndex,
          'expansionPanel-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );

        break;
      case 'Step':
        this.prepareJson(
          elementIndex,
          'step-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );

        break;
      case 'DateRangeInput':
        this.prepareJson(
          elementIndex,
          'dateRangeInput-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );

        break;
      case 'Number':
        this.prepareJson(
          elementIndex,
          'number-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );

        break;
      case 'Email':
        this.prepareJson(
          elementIndex,
          'email-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );

        break;
      case 'PasswordInput':
        this.prepareJson(
          elementIndex,
          'password-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );
        break;

      case 'DateInput':
        this.prepareJson(
          elementIndex,
          'dateInput-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );

        break;

      case 'DateTimeInput':
        this.prepareJson(
          elementIndex,
          'dateInput-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );

        break;

      case 'TIME':
        this.prepareJson(
          elementIndex,
          'time-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );

        break;

      case 'AutoComplete':
        this.prepareJson(
          elementIndex,
          'mateAutocomplete-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );

        break;
      case 'Editor':
        this.prepareJson(
          elementIndex,
          'editor-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );

        break;
      case 'CheckBox':
        this.prepareJson(
          elementIndex,
          'checkbox-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );
        break;

      case 'Button':
        this.prepareJson(
          elementIndex,
          'button-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );
        break;
      case 'RadioButton':
        this.prepareJson(
          elementIndex,
          'radio-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );
        break;

      case 'ListBox':
        this.prepareJson(
          elementIndex,
          'listBox-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );
        break;

      case 'Questionnaire':
        this.prepareJson(
          elementIndex,
          'questionnaire-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );
        break;

      case 'TextArea':
        this.prepareJson(
          elementIndex,
          'textarea-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );
        break;

      case 'DataTable':
        this.layoutValue = 12;
        this.prepareJson(
          elementIndex,
          'datatable-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          true,
          componentObj
        );
        break;
      case 'Column':
        this.layoutValue = 12;
        this.prepareJson(
          elementIndex,
          'Column-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          true,
          componentObj
        );
        break;
      case 'Card':
        this.layoutValue = 12;
        this.prepareJson(
          elementIndex,
          'card-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          true,
          componentObj
        );
        break;
      case 'AppGenCheckList':
        this.layoutValue = 12;
        this.prepareJson(
          elementIndex,
          'checkList-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          true,
          componentObj
        );
        break;
      case 'ToggleButton':
        this.prepareJson(
          elementIndex,
          'toggleButton-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          true,
          componentObj
        );
        break;
      case 'ToggleRadio':
        this.prepareJson(
          elementIndex,
          'toggleRadio-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          true,
          componentObj
        );
        break;
      case 'ToggleCheckbox':
        this.prepareJson(
          elementIndex,
          'toggleCheckBox-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );
        break;
      case 'Icon':
        this.prepareJson(
          elementIndex,
          'icon-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );
        break;
      case 'MatSelect':
        this.prepareJson(
          elementIndex,
          'matSelect-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );
        break;

      case 'NgSelect':
        this.prepareJson(
          elementIndex,
          'ngSelect-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          true,
          event,
          false,
          componentObj
        );
        break;

      case 'Address':
        this.prepareJson(
          elementIndex,
          'address-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );
        break;
      case 'Note':
        this.prepareJson(
          elementIndex,
          'note-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );
        break;
      case 'HtmlContent':
        this.prepareJson(
          elementIndex,
          'htmlContent-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );
        break;
      case 'Grid':
        this.prepareJson(
          elementIndex,
          'dgGrid-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          true,
          componentObj
        );
        break;

      case 'AppTree':
        this.prepareJson(
          elementIndex,
          'dgTree-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );
        break;
      case 'UploadFile':
        this.prepareJson(
          elementIndex,
          'fileUpload-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );
        break;
      case 'HyperLink':
        this.prepareJson(
          elementIndex,
          'hyperlink-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );
        break;
      case 'DeveloperForm':
        this.prepareJson(
          elementIndex,
          'developerForm-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );
        break;
      case 'EmployeeSearch':
        this.prepareJson(
          elementIndex,
          'employeeSearch-' + Number(this.count),
          orderNumber,
          previousAddedIndex,
          false,
          event,
          false,
          componentObj
        );

        break;
    }

    this.count = this.count + 1;
  }

  prepareJson(
    elementIndex: any,
    cmpName: any,
    orderNumber: any,
    previousAddedIndex: any,
    isControl: any,
    event: any,
    isLayout: any,
    componentObj: any
  ) {
    if (isControl) {
      this.expForm.addControl(cmpName, new FormControl());
    }
    this.jsonField = [
      this.createAttributeJson(
        event.previousContainer.data[elementIndex].type != undefined
          ? event.previousContainer.data[elementIndex].type
          : event.previousContainer.data[elementIndex][0].type,
        cmpName,
        orderNumber,
        isLayout,
        event.currentIndex,
        previousAddedIndex,
        componentObj,
        event
      ),
    ];
  }

  createAttributeJson(
    fieldName: any,
    fieldValue: any,
    orderNumber: any,
    isLayout: any,
    currentIndex: any,
    previousAddedIndex: any,
    fieldJson: any,
    event: any
  ) {
    let jsonArrayObj: any = this.attributeList[fieldName];

    if (jsonArrayObj != undefined) {
      this.getKeys(jsonArrayObj).forEach((attributes, index) => {
        switch (jsonArrayObj[attributes].prpName) {
          case 'name':
            fieldJson[jsonArrayObj[attributes].prpName] = fieldValue;
            break;
          case 'label':
            fieldJson[jsonArrayObj[attributes].prpName] =
              jsonArrayObj[attributes].prpDesc;
            break;

          case 'ariaLabel':
            fieldJson[jsonArrayObj[attributes].prpName] =
              jsonArrayObj[attributes].prpDesc;
            break;
          case 'iconName':
            fieldJson[jsonArrayObj[attributes].prpName] =
              jsonArrayObj[attributes].defaultVal;
            break;
          case 'separatorKeysCodes':
            fieldJson[jsonArrayObj[attributes].prpName] =
              jsonArrayObj[attributes].defaultVal;
            break;
          case 'startDatePlaceHolder':
            fieldJson[jsonArrayObj[attributes].prpName] =
              jsonArrayObj[attributes].defaultVal;
            break;
          case 'endDatePlaceHolder':
            fieldJson[jsonArrayObj[attributes].prpName] =
              jsonArrayObj[attributes].defaultVal;
            break;

          case 'readonly':
            fieldJson[jsonArrayObj[attributes].prpName] =
              jsonArrayObj[attributes].defaultVal;
            break;
          case 'isMandatory':
            fieldJson[jsonArrayObj[attributes].prpName] = '';
            break;
          case 'editorConfig':
            fieldJson[jsonArrayObj[attributes].prpName] = [];
            break;
          case 'addOnBlur':
            fieldJson[jsonArrayObj[attributes].prpName] =
              jsonArrayObj[attributes].defaultVal;
            break;
          case 'order':
            fieldJson[jsonArrayObj[attributes].prpName] = orderNumber;
            break;

          case 'comboMap':
            // fieldJson[jsonArrayObj[attributes].prpName] = comboMap;
            fieldJson[jsonArrayObj[attributes].prpName] =
              jsonArrayObj[attributes].defaultVal;

            break;

          case 'cols':
            fieldJson[jsonArrayObj[attributes].prpName] = [];
            break;
          case 'addressType':
            fieldJson[jsonArrayObj[attributes].prpName] = '2';
            break;

          case 'columnConfig':
            fieldJson[jsonArrayObj[attributes].prpName] = this.convertObject(
              jsonArrayObj[attributes].defaultVal
            );
            break;

          case 'matTableColumnConfig':
            fieldJson[jsonArrayObj[attributes].prpName] = MatTableColumnConfig;
            break;

          case 'gridConfig':
            fieldJson[jsonArrayObj[attributes].prpName] = gridConfigJ;
            break;

          case 'treeDataApiUrl':
            fieldJson[jsonArrayObj[attributes].prpName] = treeDataApiUrlSt;
            break;
          case 'nodeDataUrl':
            fieldJson[jsonArrayObj[attributes].prpName] =
              '/admin/organization-details?orgId=';
            break;

          case 'nodeInsertUrl':
            fieldJson[jsonArrayObj[attributes].prpName] =
              '/admin/insert-new-organization-detailss';
            break;

          case 'isAddNodeEnabled':
            fieldJson[jsonArrayObj[attributes].prpName] = true;
            break;
          case 'isIcon':
            fieldJson[jsonArrayObj[attributes].prpName] = false;
            break;
          case 'iconName':
            fieldJson[jsonArrayObj[attributes].prpName] = 'home';
            break;
          case 'url':
            fieldJson[jsonArrayObj[attributes].prpName] =
              '/appgen/applications';
            break;
          case 'params':
            fieldJson[jsonArrayObj[attributes].prpName] = [];
            break;
          case 'acceptedType':
            fieldJson[jsonArrayObj[attributes].prpName] = ['jpg', 'png'];
            break;

          case 'activeFlag':
            fieldJson[jsonArrayObj[attributes].prpName] = 1;
            break;

          case 'title':
            fieldJson[jsonArrayObj[attributes].prpName] = 'test';
            break;
          case 'updatedUserId':
            fieldJson[jsonArrayObj[attributes].prpName] = null;
            break;
          case 'updatedDate':
            fieldJson[jsonArrayObj[attributes].prpName] = null;
            break;
          case 'refreshAttachComponent':
            fieldJson[jsonArrayObj[attributes].prpName] = false;
            break;
          case 'profileAttachment':
            fieldJson[jsonArrayObj[attributes].prpName] = false;
            break;
          case 'uniqueAttachmentId':
            fieldJson[jsonArrayObj[attributes].prpName] = null;
            break;
          case 'maxSize':
            fieldJson[jsonArrayObj[attributes].prpName] = 8000000;
            break;
          case 'maxfiles':
            fieldJson[jsonArrayObj[attributes].prpName] = 1;
            break;
          case 'mandatory':
            fieldJson[jsonArrayObj[attributes].prpName] = true;
            break;
          case 'isMultiple':
            fieldJson[jsonArrayObj[attributes].prpName] = false;
            break;
          case 'edit':
            fieldJson[jsonArrayObj[attributes].prpName] = true;
            break;
          case 'createdUserId':
            fieldJson[jsonArrayObj[attributes].prpName] = 33;
            break;
          case 'createdDate':
            fieldJson[jsonArrayObj[attributes].prpName] =
              '2021-12-02T12:55:21.000+00:00';
            break;
          case 'attachSmall':
            fieldJson[jsonArrayObj[attributes].prpName] = true;
            break;
          case 'attachId':
            fieldJson[jsonArrayObj[attributes].prpName] = 0;
            break;
          case 'allowFileToAttach':
            fieldJson[jsonArrayObj[attributes].prpName] = true;
            break;
          case 'allowDelete':
            fieldJson[jsonArrayObj[attributes].prpName] = true;
            break;

          case 'matTooltip':
            fieldJson[jsonArrayObj[attributes].prpName] = '';
            break;
          case 'matTooltipPosition':
            fieldJson[jsonArrayObj[attributes].prpName] = 'after';
            break;
          case 'matTooltipShowDelay':
            fieldJson[jsonArrayObj[attributes].prpName] = '1000';
            break;
          case 'matTooltipHideDelay':
            fieldJson[jsonArrayObj[attributes].prpName] = '2000';
            break;
          case 'isEditable':
            fieldJson[jsonArrayObj[attributes].prpName] = true;
            break;
          case 'canEditInline':
            fieldJson[jsonArrayObj[attributes].prpName] = true;
            break;
          case 'canAddRow':
            fieldJson[jsonArrayObj[attributes].prpName] = true;
            break;
          case 'isRowSelectable':
            fieldJson[jsonArrayObj[attributes].prpName] = true;
            break;
          case 'showSearch':
            fieldJson[jsonArrayObj[attributes].prpName] = true;
            break;
          // case 'enableDisable':
          //   fieldJson[jsonArrayObj[attributes].prpName] = true;
          //   break;
          // case 'hideShow':
          //   fieldJson[jsonArrayObj[attributes].prpName] = false;
          //   break;

          default:
            fieldJson[jsonArrayObj[attributes].prpName] = '';
            break;
        }
      });
    }
    fieldJson['uuid'] = uuidv4();
    let componentId = null;
    fieldJson['componentType'] = fieldName;

    let index = this.attributeJson.findIndex((x) => x.type == fieldName);

    if (
      fieldJson['componentId'] == null ||
      fieldJson['componentId'] == undefined ||
      fieldJson['componentId'] == ''
    ) {
      componentId = this.attributeJson[index].componentId;
      fieldJson['componentId'] = this.attributeJson[index].componentId;
    } else {
      componentId = fieldJson['componentId'];
    }
    fieldJson['id'] = null;

    this.commonComboForParent(
      this.attributeJson[index],
      componentId,
      currentIndex,
      fieldJson,
      event
    );
    return fieldJson;
  }
  commonComboForParent(
    attributeJson,
    componentId,
    currentIndex,
    fieldJson,
    event
  ) {
    if (
      this.jsonData.formVersionMpgId != undefined &&
      this.jsonData.formVersionMpgId != null
    ) {
      const body1 = {
        LOC_ID: 1,
        LANG_ID: 1,
        ComboId: '533116',
        FORM_VERSION_MPG_ID: this.jsonData.formVersionMpgId,
      };
      try {
        this.httpClient
          .post('/worklist/get-combo-list', body1)
          .subscribe((res) => {
            const restemp: any = res;
            if (restemp.data.length != 0) {
              this.comboMapParentValues = restemp.data;
              this.dialogCommon(
                attributeJson.attribute,
                componentId,
                currentIndex,
                fieldJson,
                true,
                event
              );
            }
          });
      } catch (e) {}
    } else {
      let tempParentCombo = [];

      let obj = {
        optionValue: -1,
        optionText: this.jsonData.formName,
      };

      tempParentCombo.push(obj);
      this.comboMapParentValues = tempParentCombo;
      this.dialogCommon(
        attributeJson.attribute,
        componentId,
        currentIndex,
        fieldJson,
        true,
        event
      );
    }
  }
  getComboIds(comboId: any) {
    const body = {
      LOC_ID: '1',
      LANG_ID: '1',
      ComboId: comboId,
    };
    this.httpClient.post('/worklist/get-combo-list', body).subscribe((res) => {
      const restemp: any = res;
      this.comboIdData = restemp.data;
    });
  }
  fieldObj: any;
  openDialog(
    attributeJson: any,
    componentId: any,
    index: any,
    attributeJsonValue: any,
    isComponentAdded: any,
    event: any,
    comboIdData: any,
    comboMapParentValues: any
  ) {
    const dialogRef = this.dialog.open(AttributeDialogComponent, {
      data: {
        attrData: attributeJson,
        currentIndex: index,
        attributeJsonValue: attributeJsonValue,
        jsonData: this.jsonData,
        componentId: componentId,
        comboIdData: comboIdData,
        jsonComboMap: this.jsonComboMap,
        comboMapParentValues: comboMapParentValues,
        comboMapObj: this.comboMapObj,
      },
      width: '80vw',
      height: '90vh',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result && isComponentAdded) {
        this.getKeys(attributeJson).forEach((attributeName) => {
          let defalutVal = attributeJson[attributeName]?.defaultValue1;
          if (defalutVal != undefined && defalutVal != null) {
            delete attributeJson[attributeName]?.defaultValue1;
          }
        });
        try {
          this.formDesignerComponents = this.formDesignerTocomponent(
            this.formDesignerComponents
          );
          event.container.data.splice(event.currentIndex, 1);
          this.uuIdContainer = [];
          this.formDesignerComponents = this.componentToFormDesigner(
            this.formDesignerComponents
          );
          this.setTimeOut();
        } catch (e) {}
      } else {
        // this.jsonData.componetDetails[result.currentIndex] = result.attributeJ;
        this.getKeys(attributeJson).forEach((attributeName) => {
          let defalutVal = attributeJson[attributeName]?.defaultValue1;
          if (defalutVal != undefined && defalutVal != null) {
            delete attributeJson[attributeName]?.defaultValue1;
          }
        });
        if (result != false) {
          attributeJsonValue = result.attributeJ;
          this.fieldObj = result.attributeJ;
          this.event = event;
          this.jsonData['auditData'] = result.auditData;
          this.saveFormObj();
        } else {
          try {
            this.formDesignerComponents = this.formDesignerTocomponent(
              this.formDesignerComponents
            );

            this.uuIdContainer = [];
            this.formDesignerComponents = this.componentToFormDesigner(
              this.formDesignerComponents
            );
          } catch (e) {}
        }
        // this.jsonData.componetDetails = this.formDesignerComponents;
      }
    });
  }
  setTimeOut() {
    setTimeout(() => {
      this.getConnectedList();
    }, 100);
  }
  comboMapParentValues: any = [];
  dialogCommon(
    attributeJson: any,
    componentId: any,
    index: any,
    attributeJsonValue: any,
    isComponentAdded: any,
    event: any
  ) {
    if (
      attributeJsonValue.componentType != 'Questionnaire' &&
      attributeJsonValue.componentType != 'DeveloperForm'
    ) {
      this.openDialog(
        attributeJson,
        componentId,
        index,
        attributeJsonValue,
        isComponentAdded,
        event,
        this.comboIdData,
        this.comboMapParentValues
      );
    } else {
      this.callOpenDialog(
        attributeJsonValue,
        attributeJson,
        componentId,
        index,
        isComponentAdded,
        event
      );
    }
  }
  callOpenDialog(
    attributeJsonValue,
    attributeJson,
    componentId,
    index,
    isComponentAdded,
    event
  ) {
    const body = {
      LOC_ID: '1',
      LANG_ID: '1',
      ComboId:
        attributeJsonValue.componentType == 'Questionnaire'
          ? '533113'
          : attributeJsonValue.componentType == 'DeveloperForm'
          ? '533117'
          : '533112',
    };
    this.httpClient
      .post('/worklist/get-combo-list', body)
      .subscribe((res: any) => {
        this.developerFormData = res?.data;
        const comboIdDataCheckList: any = res?.data;
        this.openDialog(
          attributeJson,
          componentId,
          index,
          attributeJsonValue,
          isComponentAdded,
          event,
          comboIdDataCheckList,
          this.comboMapParentValues
        );
      });
  }
  uuIdContainer: any = [];
  checkUUID(uuId: any) {
    let flag = false;
    if (this.uuIdContainer != null && this.uuIdContainer != undefined) {
      this.getKeys(this.uuIdContainer).forEach((attributes, index) => {
        if (this.uuIdContainer[attributes] == uuId) {
          flag = true;
          return flag;
        }
      });
    }
    return flag;
  }
  componentToFormDesigner(jsonObject: any) {
    let tempArray = [];
    if (jsonObject != null && jsonObject != null) {
      this.getKeys(jsonObject).forEach((attributes, index) => {
        if (
          !Array.isArray(jsonObject[attributes]) &&
          !this.checkUUID(jsonObject[attributes].uuid) &&
          (jsonObject[attributes].type == 'DataTable' ||
            jsonObject[attributes].type == 'Column' ||
            jsonObject[attributes].type == 'Tab' ||
            jsonObject[attributes].type == 'Stepper' ||
            jsonObject[attributes].type == 'Card' ||
            jsonObject[attributes].type == 'AppGenCheckList' ||
            jsonObject[attributes].type == 'ExpansionPanel')
        ) {
          this.uuIdContainer.push(jsonObject[attributes].uuid);

          tempArray[0] = jsonObject[attributes];
          let temp = jsonObject[attributes];

          if (temp.components == undefined && temp.type == 'Card') {
            temp.components = [];

            temp.componentId = 36;
          } else if (
            temp.components == undefined &&
            temp.type == 'AppGenCheckList'
          ) {
            temp.components = [];

            temp.componentId = 65;
          } else {
            if (
              jsonObject[attributes].type == 'DataTable' ||
              jsonObject[attributes].type == 'Column' ||
              jsonObject[attributes].type == 'Tab' ||
              jsonObject[attributes].type == 'Stepper' ||
              jsonObject[attributes].type == 'ExpansionPanel'
            ) {
              this.addPropertiesInArray(temp);
            }
          }

          jsonObject.splice(attributes, 1);

          jsonObject.splice(attributes, 0, tempArray);
          tempArray = [];
        }
        if (!Array.isArray(jsonObject[attributes])) {
          if (
            !jsonObject[attributes].comboMapValues &&
            jsonObject[attributes]?.comboMap
          ) {
            if (
              jsonObject[attributes]?.comboConfigurationString != null &&
              jsonObject[attributes]?.comboConfigurationString != '' &&
              jsonObject[attributes]?.comboConfigurationString != undefined &&
              jsonObject[attributes]?.comboConfigurationString != '{}' &&
              jsonObject[attributes]?.comboConfigurationString != '""'
            ) {
              this.loadComboValues(jsonObject[attributes]);
            } else {
              if (this.comboMapObj[jsonObject[attributes]?.comboMap]) {
                jsonObject[attributes].comboMapValues = this.comboMapObj[
                  jsonObject[attributes]?.comboMap
                ];
              } else {
                if (jsonObject[attributes].componentType != 'DeveloperForm') {
                  this.setDropDown(jsonObject[attributes]?.comboMap).subscribe(
                    (res: any) => {
                      jsonObject[attributes].comboMapValues = res.data;
                      this.comboMapObj[jsonObject[attributes]?.comboMap] =
                        res.data;
                    }
                  );
                }
              }
            }
          } else {
            if (
              this.comboMapObj[jsonObject[attributes]?.comboMap] &&
              jsonObject[attributes]?.comboMap &&
              jsonObject[attributes].comboMapValues &&
              jsonObject[attributes].comboMapValues.length == 0
            ) {
              jsonObject[attributes].comboMapValues = this.comboMapObj[
                jsonObject[attributes]?.comboMap
              ];
            } else {
              if (
                jsonObject[attributes].componentType != 'DeveloperForm' &&
                jsonObject[attributes]?.comboMap
              ) {
                if (
                  jsonObject[attributes]?.comboConfigurationString != null &&
                  jsonObject[attributes]?.comboConfigurationString != '' &&
                  jsonObject[attributes]?.comboConfigurationString !=
                    undefined &&
                  jsonObject[attributes]?.comboConfigurationString != '{}' &&
                  jsonObject[attributes]?.comboConfigurationString != '""'
                ) {
                  this.loadComboValues(jsonObject[attributes]);
                } else {
                  this.setDropDown(jsonObject[attributes]?.comboMap).subscribe(
                    (res: any) => {
                      jsonObject[attributes].comboMapValues = res.data;
                      this.comboMapObj[jsonObject[attributes]?.comboMap] =
                        res.data;
                    }
                  );
                }
              }
            }
          }
        }
        if (Array.isArray(jsonObject[attributes])) {
          this.componentToFormDesigner(jsonObject[attributes]);
        }
        if (Array.isArray(jsonObject[attributes].components)) {
          this.componentToFormDesigner(jsonObject[attributes].components);
        }
      });
    }

    return jsonObject;
  }
  setDropDown(comboId, configuration?): Observable<any> {
    let body = {
      LOC_ID: '1',
      LANG_ID: '1',
      ComboId: comboId + '',
    };
    if (configuration) {
      body = Object.assign(body, configuration);
    }

    return this.httpClient.post('/worklist/get-combo-list', body);
  }
  addPropertiesInArray(temp) {
    if (Array.isArray(temp?.components)) {
      this.getKeys(temp?.components).forEach((attributes1, index) => {
        if (
          temp.components[attributes1]?.enableDisable == undefined &&
          temp.type == 'Tab'
        ) {
          temp.components[attributes1].enableDisable = false;
        }
        if (temp.components[attributes1]?.hideShow == undefined) {
          temp.components[attributes1].hideShow = false;
        }
        if (
          temp.components[attributes1]?.components == undefined &&
          temp.type == 'Stepper'
        ) {
          temp.components[attributes1].components = [];
          temp.components[attributes1].componentId = 56;
        } else if (
          temp.components[attributes1]?.components == undefined &&
          temp.type == 'Tab'
        ) {
          temp.components[attributes1].components = [];
          temp.components[attributes1].componentId = 48;
        } else if (
          temp.components[attributes1]?.components == undefined &&
          temp.type == 'ExpansionPanel'
        ) {
          temp.components[attributes1].components = [];
          temp.components[attributes1].componentId = 54;
        } else if (
          temp.components[attributes1]?.components == undefined &&
          temp.type == 'DataTable'
        ) {
          temp.components[attributes1].components = [];
          temp.components[attributes1].componentId = 35;
        } else if (
          temp.components[attributes1]?.components == undefined &&
          temp.type == 'Column'
        ) {
          temp.components[attributes1].components = [];
          temp.components[attributes1].componentId = 64;
        } else if (
          temp.components[attributes1]?.components == undefined &&
          temp.type == 'AppGenCheckList'
        ) {
          temp.components[attributes1].components = [];
          temp.components[attributes1].componentId = 65;
        }
        if (
          temp.components[attributes1]?.enableDisable == false &&
          temp.type == 'Tab'
        ) {
          temp.components[attributes1].enableDisable = {
            optionValue: 'false',
            optionText: 'false',
          };
        }
        if (
          temp.components[attributes1]?.enableDisable == true &&
          temp.type == 'Tab'
        ) {
          temp.components[attributes1].enableDisable = {
            optionValue: 'true',
            optionText: 'true',
          };
        }

        if (temp.components[attributes1]?.hideShow == false) {
          temp.components[attributes1].hideShow = {
            optionValue: 'false',
            optionText: 'false',
          };
        }
        if (temp.components[attributes1]?.hideShow == true) {
          temp.components[attributes1].hideShow = {
            optionValue: 'true',
            optionText: 'true',
          };
        }
        if (
          temp.components[attributes1]?.isEntity == false ||
          temp.components[attributes1]?.isEntity == undefined
        ) {
          temp.components[attributes1].isEntity = {
            optionValue: 'false',
            optionText: 'false',
          };
        }
        if (temp.components[attributes1]?.isEntity == true) {
          temp.components[attributes1].isEntity = {
            optionValue: 'true',
            optionText: 'true',
          };
        }
        if (
          temp.components[attributes1]?.checkDuplicate == false ||
          temp.components[attributes1]?.checkDuplicate == undefined
        ) {
          temp.components[attributes1].checkDuplicate = {
            optionValue: 'false',
            optionText: 'false',
          };
        }
        if (temp.components[attributes1]?.checkDuplicate == true) {
          temp.components[attributes1].checkDuplicate = {
            optionValue: 'true',
            optionText: 'true',
          };
        }
        if (
          temp.components[attributes1]?.prntEntityId != null &&
          temp.components[attributes1]?.prntEntityId != undefined
        ) {
          if (this.fieldObj != null && this.fieldObj != undefined) {
            this.setParentComboData(
              this.fieldObj.comboMapParentValues,
              temp.components[attributes1]
            );
          } else if (
            this.comboMapParentValues != null &&
            this.comboMapParentValues.length != 0
          ) {
            this.setParentComboData(
              this.comboMapParentValues,
              temp.components[attributes1]
            );
          } else {
            this.getParentComboDatas(temp.components[attributes1]);
          }
        } else {
          if (this.comboMapParentValues.length == 0) {
            const body1 = {
              LOC_ID: 1,
              LANG_ID: 1,
              ComboId: '533116',
              FORM_VERSION_MPG_ID: this.jsonData.formVersionMpgId,
            };
            try {
              this.httpClient
                .post('/worklist/get-combo-list', body1)
                .subscribe((res) => {
                  const restemp: any = res;
                  if (restemp.data.length != 0) {
                    this.comboMapParentValues = restemp.data;
                  }
                });
            } catch (e) {}
          }
        }
      });
    }
  }
  getParentComboDatas(fieldData) {
    const body1 = {
      LOC_ID: 1,
      LANG_ID: 1,
      ComboId: '533116',
      FORM_VERSION_MPG_ID: this.jsonData.formVersionMpgId,
    };
    try {
      this.httpClient
        .post('/worklist/get-combo-list', body1)
        .subscribe((res) => {
          const restemp: any = res;
          if (restemp.data.length != 0) {
            this.comboMapParentValues = restemp.data;
            this.setParentComboData(restemp.data, fieldData);
            return restemp.data;
          }
        });
    } catch (e) {}
  }
  setParentComboData(restTemp, fieldData) {
    this.getKeys(restTemp).forEach((index) => {
      if (
        restTemp[index].optionValue == fieldData.prntEntityId ||
        restTemp[index].optionValue == -1
      ) {
        fieldData.prntEntityId = {
          optionValue: fieldData.prntEntityId,
          optionText: restTemp[index].optionText,
        };
      }
    });
  }

  setParentComboFieldData(obj, field) {
    if (
      obj != null &&
      obj.length != 0 &&
      (field?.type == 'Tab' || field?.type == 'Stepper')
    ) {
      this.getKeys(field.comboMapParentValues).forEach((index) => {
        let jsonObj = {
          extendedVO: null,
          customXidBean: null,
          dbSchema: null,
          optionValue: field.comboMapParentValues[index].optionValue,
          optionText: field.comboMapParentValues[index].optionText,
          optionDesc: '',
          attrValue: '',
        };
        obj.forEach((element) => {
          if (element.columnName == 'Parent Entity') {
            element.comboItems.push(jsonObj);
          }
        });
      });
    }
  }
  saveFormObj() {
    this.jsonData.componetDetails = this.formDesignerTocomponent(
      this.formDesignerComponents
    );
    this.jsonData.form_status = this.formStatus;
    this.jsonData.formName = this.formName;

    // this.jsonData.form_status = result.version;
    //  console.log('json before save--', JSON.stringify(this.jsonData));

    // AUDIT
    if (this.auditService.auditDragList.length > 0) {
      this.jsonData['auditData'] = this.auditService.auditDragList;
      // RESET
      this.auditService.auditDragList = [];
      this.auditService.resetAuditV2();
    }
    this.saveFormData(this.jsonData).subscribe(
      (res: any) => {
        if (res.data.status) {
          this.msgDsplyService.errorToast({
            errors: [
              {
                message: res.messages?.[0],
              },
            ],
          });
          this.router.navigate(['main/appgen-form-version'], {
            queryParams: {
              formIdToSend: this.formId,
              appId: this.appId,
              appName: this.appName,
            },
          });
        } else {
          if (!this.jsonData.form_status) {
            this.jsonData.form_status = true;

            this.jsonData = res.data.resultValue;
            this.formStatus = true;
            let queryParams = {
              formIdToSend: this.jsonData.formId,
              formStatus: true,
              appId: this.appId,
            };

            this.router.navigate(['main/appgen-main-container'], {
              queryParams: queryParams,
            });
          }
          this.jsonData.form_status = true;

          this.formStatus = true;
          this.jsonData = res.data.resultValue;
          this.uuIdContainer = [];

          if (res.data.resultValue.componetDetails.length != 0) {
            this.formDesignerComponents = this.componentToFormDesigner(
              res.data.resultValue.componetDetails
            );
          } else {
            this.formDesignerComponents = [];
          }
          // console.log('json before save--', JSON.stringify(res.data.resultValue));

          this.setTimeOut();

          this.msgDsplyService.successToast({
            messages: ['Component Saved successfully'],
          });
        }
      },
      (error) => {
        this.event?.container?.data.splice(this.event?.currentIndex, 1);
        this.jsonData.componetDetails = this.formDesignerComponents;
      },
      () => {
        console.log('Observable completed');
      }
    );
  }

  checkDataTable: any = false;
  checkDataTableObj(jsonObject: any, event: any) {
    this.getKeys(jsonObject).forEach((attributes, index) => {
      if (
        Array.isArray(jsonObject[attributes]) &&
        jsonObject[attributes]?.[0].type == 'DataTable'
      ) {
        let component = jsonObject[attributes]?.[0].components;
        this.getKeys(component).forEach((attributes1, index) => {
          let childComponent = component[attributes1].components;
          if (childComponent.length == 2) {
            event.container.data.splice(event.currentIndex, 1);
            this.checkDataTable = true;

            this.msgDsplyService.errorToast({
              errors: [
                {
                  message: 'You can add only single component in a column',
                },
              ],
            });
            return this.checkDataTable;
          }
          this.getKeys(childComponent).forEach((attributes2, index) => {
            if (childComponent[attributes2].type == 'Label') {
              event.container.data.splice(event.currentIndex, 1);
              this.checkDataTable = true;

              this.msgDsplyService.errorToast({
                errors: [
                  {
                    message: 'You can not add label in DataTable',
                  },
                ],
              });
              return this.checkDataTable;
            }
          });
        });
      }
      if (
        Array.isArray(jsonObject[attributes]) &&
        jsonObject[attributes]?.[0].type == 'AppGenCheckList'
      ) {
        let component = jsonObject[attributes]?.[0].components;
        this.getKeys(component).forEach((attributes1, index) => {
          let componentType = null;
          if (Array.isArray(component[attributes1])) {
            componentType = component[attributes1][0]?.type;
          } else {
            componentType = component[attributes1]?.type;
          }
          if (
            componentType == 'Tab' ||
            componentType == 'Card' ||
            componentType == 'Stepper' ||
            componentType == 'ExpansionPanel' ||
            componentType == 'AppGenCheckList'
          ) {
            event.container.data.splice(event.currentIndex, 1);
            this.checkDataTable = true;
            this.msgDsplyService.errorToast({
              errors: [
                {
                  message:
                    'You can not add  ' + componentType + ' in checklist',
                },
              ],
            });
            return this.checkDataTable;
          }
        });
      }
      if (Array.isArray(jsonObject[attributes])) {
        this.checkDataTableObj(jsonObject[attributes], event);
      }
      if (!Array.isArray(jsonObject[attributes])) {
        if (jsonObject[attributes]?.type == 'DataTable') {
          let component = jsonObject[attributes]?.components;
          this.getKeys(component).forEach((attributes1, index) => {
            let childComponent = component[attributes1].components;
            if (childComponent.length == 2) {
              event.container.data.splice(event.currentIndex, 1);
              this.checkDataTable = true;
              this.msgDsplyService.errorToast({
                errors: [
                  {
                    message: 'You can add only single component in a column',
                  },
                ],
              });
              return this.checkDataTable;
            }
            this.getKeys(childComponent).forEach((attributes2, index) => {
              if (childComponent[attributes2].type == 'Label') {
                event.container.data.splice(event.currentIndex, 1);
                this.checkDataTable = true;

                this.msgDsplyService.errorToast({
                  errors: [
                    {
                      message: 'You can not add label in DataTable',
                    },
                  ],
                });
                return this.checkDataTable;
              }
            });
          });
        }
        if (jsonObject[attributes]?.type == 'AppGenCheckList') {
          let component = jsonObject[attributes]?.components;
          this.getKeys(component).forEach((attributes1, index) => {
            let componentType = component[attributes1].type;
            if (
              componentType == 'Tab' ||
              componentType == 'Card' ||
              componentType == 'Stepper' ||
              componentType == 'ExpansionPanel' ||
              componentType == 'Column'
            ) {
              event.container.data.splice(event.currentIndex, 1);
              this.checkDataTable = true;
              this.msgDsplyService.errorToast({
                errors: [
                  {
                    message:
                      'You can not add  ' + componentType + ' in checklist',
                  },
                ],
              });
              return this.checkDataTable;
            }
          });
        }
      }
      if (
        jsonObject[attributes] != undefined &&
        Array.isArray(jsonObject[attributes].components)
      ) {
        this.checkDataTableObj(jsonObject[attributes].components, event);
      }
    });

    return this.checkDataTable;
  }
  formDesignerTocomponent(jsonObject: any) {
    let tempArray;

    this.getKeys(jsonObject).forEach((attributes, index) => {
      if (
        Array.isArray(jsonObject[attributes]) &&
        (jsonObject[attributes]?.[0].type == 'DataTable' ||
          jsonObject[attributes]?.[0].type == 'Column' ||
          jsonObject[attributes]?.[0].type == 'Tab' ||
          jsonObject[attributes]?.[0].type == 'Card' ||
          jsonObject[attributes]?.[0].type == 'AppGenCheckList' ||
          jsonObject[attributes]?.[0].type == 'Stepper' ||
          jsonObject[attributes]?.[0].type == 'ExpansionPanel')
      ) {
        tempArray = jsonObject[attributes];

        let temp = jsonObject[attributes];

        this.tempComponents(temp);

        if (
          jsonObject[attributes][0]?.displayOrder == undefined ||
          jsonObject[attributes][0]?.displayOrder != attributes ||
          jsonObject[attributes][0]?.isAddUpdate != null
        ) {
          jsonObject[attributes][0].isAddUpdate = 'update';
        } else {
          jsonObject[attributes][0].isAddUpdate = null;
        }
        jsonObject[attributes][0].displayOrder = attributes;

        jsonObject.splice(attributes, 1);

        jsonObject.splice(attributes, 0, tempArray[0]);

        tempArray = null;
      }
      if (Array.isArray(jsonObject[attributes])) {
        if (
          jsonObject[attributes][0]?.displayOrder == undefined ||
          jsonObject[attributes][0]?.displayOrder != attributes ||
          jsonObject[attributes][0]?.isAddUpdate != null
        ) {
          jsonObject[attributes][0].isAddUpdate = 'update';
        } else {
          jsonObject[attributes][0].isAddUpdate = null;
        }
        jsonObject[attributes][0].displayOrder = attributes;

        this.formDesignerTocomponent(jsonObject[attributes]);
      }
      if (!Array.isArray(jsonObject[attributes])) {
        if (jsonObject[attributes]?.type == 'empty') {
          delete jsonObject[attributes];
        } else {
          if (
            jsonObject[attributes]?.type != 'empty' &&
            (jsonObject[attributes]?.displayOrder == undefined ||
              jsonObject[attributes]?.displayOrder != attributes ||
              jsonObject[attributes]?.isAddUpdate != null)
          ) {
            jsonObject[attributes].isAddUpdate = 'update';
          } else {
            jsonObject[attributes].isAddUpdate = null;
          }
          jsonObject[attributes].displayOrder = attributes;
          if (
            jsonObject[attributes]?.type == 'TextInput' &&
            !jsonObject[attributes].maxLength
          ) {
            jsonObject[attributes].maxLength = 100;
          } else if (
            jsonObject[attributes]?.type == 'Email' &&
            !jsonObject[attributes]?.maxLength
          ) {
            jsonObject[attributes].maxLength = 100;
          } else if (
            jsonObject[attributes]?.type == 'TextArea' &&
            !jsonObject[attributes]?.maxLength
          ) {
            jsonObject[attributes].maxLength = 300;
          } else if (
            jsonObject[attributes]?.type == 'Password' &&
            !jsonObject[attributes]?.maxLength
          ) {
            jsonObject[attributes].maxLength = 50;
          } else if (
            jsonObject[attributes]?.type == 'DataTable' &&
            !jsonObject[attributes]?.maximumRowCount
          ) {
            jsonObject[attributes].maximumRowCount = 10000;
          }
          if (
            jsonObject[attributes]?.type == 'DataTable' ||
            jsonObject[attributes]?.type == 'Column' ||
            jsonObject[attributes]?.type == 'Tab' ||
            jsonObject[attributes]?.type == 'Stepper' ||
            jsonObject[attributes]?.type == 'ExpansionPanel'
          ) {
            this.tempComponents(jsonObject[attributes]);
          }
        }
      }
      if (
        jsonObject[attributes] != undefined &&
        Array.isArray(jsonObject[attributes].components)
      ) {
        this.formDesignerTocomponent(jsonObject[attributes].components);
      }
    });

    return jsonObject;
  }

  tempComponents(temp) {
    if (temp.components != null && temp.components != undefined) {
      this.getKeys(temp.components).forEach((attributes1, index) => {
        if (temp.type == 'Stepper') {
          temp.components[attributes1].componentId = 56;
        } else if (temp.type == 'Tab') {
          temp.components[attributes1].componentId = 48;
        } else if (temp.type == 'ExpansionPanel') {
          temp.components[attributes1].componentId = 37;
        } else if (temp.type == 'DataTable') {
          temp.components[attributes1].componentId = 35;
        } else if (temp.type == 'Column') {
          temp.components[attributes1].componentId = 64;
        }

        if (temp.components[attributes1].hideShow?.optionValue == 'true') {
          temp.components[attributes1].hideShow = true;
        } else {
          temp.components[attributes1].hideShow = false;
        }
        if (temp?.type == 'Tab') {
          if (
            temp?.components[attributes1]?.enableDisable?.optionValue == 'true'
          ) {
            temp.components[attributes1].enableDisable = true;
          } else {
            temp.components[attributes1].enableDisable = false;
          }
        }
        if (temp.components[attributes1].isEntity?.optionValue == 'true') {
          temp.components[attributes1].isEntity = true;
        } else {
          temp.components[attributes1].isEntity = false;
        }
        if (
          temp.components[attributes1].checkDuplicate?.optionValue == 'true'
        ) {
          temp.components[attributes1].checkDuplicate = true;
        } else {
          temp.components[attributes1].checkDuplicate = false;
        }
        if (
          temp.components[attributes1].prntEntityId?.optionValue != null &&
          temp.components[attributes1].prntEntityId?.optionValue != undefined
        ) {
          temp.components[attributes1].prntEntityId =
            temp.components[attributes1].prntEntityId?.optionValue;
        }
      });
    }
  }
  defaultVal: any = null;
  getComponentId(jsonObject: any, componentId: any) {
    this.getKeys(jsonObject).forEach((component) => {
      if (jsonObject[component].id == componentId) {
        this.defaultVal = jsonObject[component].defaultValue;
        return this.defaultVal;
      }
      if (Array.isArray(jsonObject[component])) {
        this.getComponentId(jsonObject[component], componentId);
      }
      if (Array.isArray(jsonObject[component]?.components)) {
        this.getComponentId(jsonObject[component]?.components, componentId);
      }
    });
    return this.defaultVal;
  }
  loadComboValues(formDesignerComponent: any) {
    let comboConfigurationString: any;

    if (formDesignerComponent.comboMap) {
      let value = formDesignerComponent.comboMap;
      if (typeof formDesignerComponent.comboConfigurationString === 'string') {
        if (
          !formDesignerComponent.comboConfigurationString.replace(/\\/g, '')
            .length
        ) {
          comboConfigurationString = null;
        } else {
          comboConfigurationString =
            formDesignerComponent.comboConfigurationString;
        }
      }
      if (
        typeof formDesignerComponent.comboConfigurationString === 'object' &&
        Object.keys(formDesignerComponent.comboConfigurationString).length == 0
      ) {
        comboConfigurationString = null;
      } else {
        comboConfigurationString =
          formDesignerComponent.comboConfigurationString;
      }
      this.populateCombo(
        formDesignerComponent,
        value,
        comboConfigurationString
      );
    }
    //});
  }
  dependentFlag: any = false;
  populateCombo(obj: any, value: any, comboConfigurationString: any) {
    let extractedComponentId: any;
    let dependentParentComboId: any;
    let tempComboConfigurationString: any = {};
    this.dependentFlag = false;
    const body1 = {
      LOC_ID: '1',
      LANG_ID: '1',
      ComboId: value.toString(),
    };
    var body: any = {};

    if (comboConfigurationString) {
      if (
        typeof comboConfigurationString === 'string' &&
        this.isJson(comboConfigurationString)
      ) {
        comboConfigurationString = comboConfigurationString.replace(/\\/g, '');
        try {
          comboConfigurationString = JSON.parse(comboConfigurationString);
        } catch (e) {
          comboConfigurationString = {};
        }
      }

      // tempComboConfigurationString=comboConfigurationString;
      tempComboConfigurationString = Object.assign(
        {},
        comboConfigurationString
      );
      for (var key in tempComboConfigurationString) {
        if (
          tempComboConfigurationString[key].toString().includes('ComponentId')
        ) {
          let tempString = tempComboConfigurationString[key].toString();
          extractedComponentId = tempString.split('_')[1];
          this.defaultVal = null;
          dependentParentComboId = this.getComponentId(
            this.jsonData.componetDetails,
            extractedComponentId
          );
          if (
            dependentParentComboId != undefined &&
            dependentParentComboId != null
          ) {
            tempComboConfigurationString[
              key
            ] = dependentParentComboId.toString();
          } else {
            this.dependentFlag = true;
          }
        }
      }
      body = Object.assign(body1, tempComboConfigurationString);
    } else {
      body = Object.assign({}, body1);
    }
    if (!this.dependentFlag) {
      this.httpClient.post('/worklist/get-combo-list', body).subscribe(
        (res) => {
          const restemp: any = res;
          obj.comboMapValues = restemp.data;
        },
        (err: any) => {
          console.log('Error in combo', err);
        }
      );
    }
  }
  getSelectedComboValue(selectedComboValue: any) {
    this.selectedParentComboValue = selectedComboValue;
  }
  convertObject(fieldValue: any) {
    let comboObj: any;

    if (typeof fieldValue == 'string') {
      comboObj = JSON.parse(fieldValue.replace(/\\/g, ''));
      return comboObj;
    } else if (typeof fieldValue == 'boolean') {
      return fieldValue;
    } else if (typeof fieldValue == 'number') {
      return fieldValue;
    }
  }

  removeComponent(data: any) {
    let item = null;
    if (data?.items == undefined) {
      item = data;
    } else {
      item = data.items;
    }
    let name = null;
    if (Array.isArray(item)) {
      name = item[0].label;
    } else {
      name = item.label;
    }
    this.dialogService
      .confirmation(
        'Are you sure to delete the ' + name + ' component',
        'Yes',
        'No'
      )
      .afterClosed()
      .subscribe((res) => {
        console.log(res);
        if (res) {
          let audit = this.auditService.deleteComponent(item);
          this.auditData = [audit];
          // RESET AUDITV2
          this.auditService.resetAuditV2();
          this.removeAndUpdateComponents(
            this.formDesignerComponents,
            item,
            false
          );
        }
      });
  }
  removeAndUpdateComponents(
    jsonObject: any,
    items: any,
    isUpdateOrDelete: any
  ) {
    this.getKeys(jsonObject).forEach((component) => {
      if (
        Array.isArray(jsonObject[component]) &&
        jsonObject[component]?.[0].uuid == items.uuid
      ) {
        if (isUpdateOrDelete == true) {
          jsonObject = items;
          this.jsonData.componetDetails = this.formDesignerComponents;
        } else {
          jsonObject[component][0].deleteComponent = 'delete';
          jsonObject[component][0].isAddUpdate = 'update';
          this.deleteAllObj(jsonObject[component]);
          this.deleteObject(jsonObject, component);
          return;
        }
      }
      if (
        (jsonObject[component]?.uuid == items?.uuid &&
          jsonObject[component]?.uuid &&
          items?.uuid) ||
        (jsonObject[component]?.id == items?.id &&
          jsonObject[component]?.id &&
          items?.id)
      ) {
        if (isUpdateOrDelete == true) {
          jsonObject = items;
          this.jsonData.componetDetails = this.formDesignerComponents;
        } else {
          jsonObject[component].deleteComponent = 'delete';
          jsonObject[component].isAddUpdate = 'update';
          if (Array.isArray(jsonObject[component]?.components)) {
            this.deleteAllObj(jsonObject[component]);
          }
          this.deleteObject(jsonObject, component);
          return;
        }
      }
      if (Array.isArray(jsonObject[component])) {
        this.removeAndUpdateComponents(
          jsonObject[component],
          items,
          isUpdateOrDelete
        );
      }
      if (Array.isArray(jsonObject[component]?.components)) {
        this.removeAndUpdateComponents(
          jsonObject[component]?.components,
          items,
          isUpdateOrDelete
        );
      }
    });
  }
  deleteAllObj(jsonObject: any) {
    this.getKeys(jsonObject)?.forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        jsonObject[component].deleteComponent = 'delete';
        jsonObject[component].isAddUpdate = 'update';
      }

      if (Array.isArray(jsonObject[component])) {
        jsonObject[component][0].deleteComponent = 'delete';
        jsonObject[component][0].isAddUpdate = 'update';
        this.deleteAllObj(jsonObject[component]);
      }
      if (Array.isArray(jsonObject[component]?.components)) {
        this.deleteAllObj(jsonObject[component]?.components);
      }
    });
    return jsonObject;
  }
  getActiveFormDesignerComponent(jsonObject: any, items: any) {
    this.getKeys(jsonObject).forEach((component) => {
      if (
        Array.isArray(jsonObject[component]) &&
        jsonObject[component]?.[0].uuid == items.uuid
      ) {
        return jsonObject;
      }
      if (jsonObject[component].uuid == items.uuid) {
        return jsonObject;
      }
      if (Array.isArray(jsonObject[component])) {
        this.getActiveFormDesignerComponent(jsonObject[component], items);
      }
      if (Array.isArray(jsonObject[component]?.components)) {
        this.getActiveFormDesignerComponent(
          jsonObject[component]?.components,
          items
        );
      }
    });
    return jsonObject;
  }
  deleteObject(jsonObject: any, component: any) {
    this.jsonData.form_status = this.formStatus;
    //this.jsonData.componetDetails = this.formDesignerComponents;
    this.jsonData.componetDetails = this.formDesignerTocomponent(
      this.formDesignerComponents
    );
    // PASSING AUDITDATA IN ARRAY
    this.jsonData['auditData'] = this.auditData;
    this.saveFormData(this.jsonData).subscribe((res: any) => {
      if (res.data.status) {
        this.msgDsplyService.errorToast({
          errors: [
            {
              message: res.messages?.[0],
            },
          ],
        });
        this.router.navigate(['main/appgen-form-version'], {
          queryParams: {
            formIdToSend: this.formId,
            appId: this.appId,
            appName: this.appName,
          },
        });
      } else {
        this.jsonData = res.data.resultValue;
        this.jsonData.form_status = true;
        this.formStatus = true;
        if (res.data.resultValue.componetDetails.length != 0) {
          this.uuIdContainer = [];
          this.formDesignerComponents = this.componentToFormDesigner(
            res.data.resultValue.componetDetails
          );
          this.setTimeOut();
        } else {
          this.formDesignerComponents = [];
        }
        //  jsonObject.splice(component, 1);
      }
    });
  }
  updateComponentIdsNull(jsonObject: any) {
    this.getKeys(jsonObject).forEach((component) => {
      if (jsonObject[component].id != null) {
        jsonObject[component].id = null;
        if (
          jsonObject[component].roleConfiguration != null &&
          jsonObject[component].roleConfiguration.length != 0
        ) {
          this.getKeys(jsonObject[component].roleConfiguration).forEach(
            (component) => {
              jsonObject[component].roleConfiguration[
                component
              ].cmpRolePrivId = null;
            }
          );
        }
        if (
          jsonObject[component].tableConfiguration != null &&
          jsonObject[component].tableConfiguration.length != 0
        ) {
          this.getKeys(jsonObject[component].tableConfiguration).forEach(
            (component) => {
              jsonObject[component].tableConfiguration[
                component
              ].formTblMpgId = null;
            }
          );
        }
        jsonObject[component].ruleConfiguration = [];
        jsonObject[component].eventConfiguration = [];
      }
      if (Array.isArray(jsonObject[component])) {
        this.updateComponentIdsNull(jsonObject[component]);
      }
      if (Array.isArray(jsonObject[component]?.components)) {
        this.updateComponentIdsNull(jsonObject[component]?.components);
      }
    });
  }
  OnClickComp(data: any) {
    this.jsonDataRaw = JSON.stringify(data);
    // RESET
    this.auditService.resetAuditV2();
    let type = null;
    let jsonData = null;
    if (data?.com?.type == undefined) {
      type = data.type;
      jsonData = data;
    } else {
      type = data?.com?.type;
      jsonData = data.com;
    }
    let index = this.attributeJson.findIndex((x) => x.type == type);

    if (this.comboMapParentValues.length != 0) {
      if (
        this.comboMapParentValues.length == 1 &&
        this.comboMapParentValues[0].optionValue == -1
      ) {
        this.callForParentCombo(index, jsonData);
      } else {
        this.dialogCommon(
          this.attributeJson[index].attribute,
          this.attributeJson[index].componentId,
          1,
          jsonData,
          false,
          null
        );
      }
    } else {
      this.callForParentCombo(index, jsonData);
    }
  }
  callForParentCombo(index, jsonData) {
    const body1 = {
      LOC_ID: 1,
      LANG_ID: 1,
      ComboId: '533116',
      FORM_VERSION_MPG_ID: this.jsonData.formVersionMpgId,
    };
    try {
      this.httpClient
        .post('/worklist/get-combo-list', body1)
        .subscribe((res) => {
          const restemp: any = res;
          if (restemp.data.length != 0) {
            this.comboMapParentValues = restemp.data;
            this.dialogCommon(
              this.attributeJson[index].attribute,
              this.attributeJson[index].componentId,
              1,
              jsonData,
              false,
              null
            );
          }
        });
    } catch (e) {}
  }
  DeleteTableCol(index, tableData) {
    tableData.splice(index, 1);
  }
  AllowComp(index, AData) {
    alert('Drag and Drop Only One Component Allow in Column !');
    AData.splice(index, 1);
  }

  AddGrideCol(tableData) {
    let colLength: any = tableData.length;
    colLength = colLength + 1;
    const addData: any = {
      Label: 'Col ' + colLength,
      Name: 'col' + colLength,
      components: [],
    };

    tableData.push(addData);
    this.setTimeOut();
  }

  configTable() {
    this.jsonComboMap.tableList = null;
    const addTableDialog = this.dialog.open(TableConfigDialogComponent, {
      width: '80vw',
      height: '90vh',
      data: { jsonData: this.jsonData },
    });
    addTableDialog.afterClosed().subscribe((result) => {
      if (result) {
        if (this.jsonData == null || this.jsonData == undefined) {
          this.jsonData = {
            form_status: false,
            formId: this.formId,
            componetDetails: [],
          };
        }
        if (result != undefined) {
          this.jsonData.tableConfiguration = result.tableConfiguration;
          this.jsonData['auditData'] = result.audit;
        }

        this.saveFormObj();
      }
    });
  }

  configAdvancedRule() {
    this.jsonComboMap.tableList = null;
    const addTableDialog = this.dialog.open(AdvancedRuleScreenComponent, {
      width: '80vw',
      height: '90vh',
      data: { jsonData: this.jsonData },
    });
    addTableDialog.afterClosed().subscribe((result) => {
      console.log('closed');
    });
  }

  configAudit(appId?, formVersionMpgId?) {
    let postData = {
      appId: this.appId ? this.appId : appId,
      formVersionMpgId: this.jsonData.formVersionMpgId
        ? this.jsonData.formVersionMpgId
        : formVersionMpgId,
    };
    this.auditService.getAppgenAudit(postData).subscribe((res) => {
      console.log('Audit data', res);
      const addTableDialog = this.dialog.open(ConfigurationAuditComponent, {
        width: '80vw',
        height: '90vh',
        data: { auditData: res },
      });
      addTableDialog.afterClosed().subscribe((result) => {
        console.log('Auuuudit:::');
      });
    });
  }

  assignQuestionnaire(dataforAssign): Observable<any> {
    return this.httpClient
      .post(`/request-mapping/assign-to`, dataforAssign)
      .pipe(
        map((response: any) => response?.data),
        catchError((error) => throwError(error))
      );
  }
  submitAndSaveQuestionnaire(dataForPost: any): Observable<any> {
    return this.httpClient
      .post(`/request-mapping/submit-response`, dataForPost)
      .pipe(
        map((response: any) => response?.data),
        catchError((error) => throwError(error))
      );
  }
}
